export { default as Dashboard } from './Dashboard';
export const RESOURCE_ANALYTICS: string = 'analytics';
